import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue-demi';
import {
  AbSection,
  AbContainer,
  AbSectionLayout,
  AbTitle,
  AbDescription,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import SocialSectionInstagramSlider from './SocialSectionInstagramSlider.vue';
import SocialSectionInstagramGrid from './SocialSectionInstagramGrid.vue';
import { useSectionAnalytics } from '../../../../analytics';

export interface InstagramPostItem {
  caption: string;
  link: string;
  media_url: string;
  published_at: string;
  media_type?: string;
}

interface Props {
  id?: string | null;
  spacing?: Spacing | null;
  title: string;
  description?: string | null;
  count: number;
  analytics_placement?: string | null;
  gridView?: boolean | null;
  items?: InstagramPostItem[];
  errorText?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialSectionInstagram',
  props: {
    id: null,
    spacing: null,
    title: null,
    description: null,
    count: null,
    analytics_placement: null,
    gridView: { type: [Boolean, null] },
    items: null,
    errorText: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  spacing?: Spacing | null;
  title: string;
  description?: string | null;
  count: number;
  analytics_placement?: string | null;
  gridView?: boolean | null;
  items?: InstagramPostItem[];
  errorText?: string | null;
};



const view = computed(() =>
  !props.gridView ? SocialSectionInstagramSlider : SocialSectionInstagramGrid,
);

const sectionRef = ref<HTMLElement | null>(null);

const analyticItems = computed(() =>
  (props.items ?? []).map((item: any) => ({
    destination_url: item?.link ?? '',
    creative_name: '',
  })),
);

const { trackSelectItem } = useSectionAnalytics(
  sectionRef,
  {
    placement: props.analytics_placement ?? '',
    items: analyticItems.value,
  },
  {
    mode: props.gridView ? 'section' : 'carousel',
    sectionName: 'SocialSectionInstagram',
  },
);

const handleItemClickAny = (index: number) => {
  const item = props.items?.[index];
  if (item) {
    trackSelectItem({
      destination_url: item?.link ?? '',
      creative_name: 'post-click',
    });
  } else {
    trackSelectItem(index);
  }
};

const handleAutoplayToggle = (index: number) => {
  const item = props.items?.[index];
  if (item) {
    trackSelectItem({
      destination_url: item?.link ?? '',
      creative_name: 'play-button-click',
    });
  } else {
    trackSelectItem(index);
  }
};

return { __sfc: true,props, view, sectionRef, analyticItems, trackSelectItem, handleItemClickAny, handleAutoplayToggle, AbSection, AbContainer, AbSectionLayout, AbTitle, AbDescription }
}

})